import { combineReducers } from 'redux';
import types from './types';

export interface IPaySimpleError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IPaySimpleError = {
  hasFailed: false,
  message: ''
};

const data = (
  state: any = [],
  { type, payload }: { type: string; payload: any[] }
) => {
  switch (type) {
    case types.SET_PAYMENT_DATA:
      return payload;

    default:
      return state;
  }
};

const pageNumber = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_PAYMENT_PAGE_NUMBER:
      return payload;

    default:
      return state;
  }
};

const pageSize = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_PAYMENT_PAGE_SIZE:
      return payload;

    default:
      return state;
  }
};

const totalElements = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_PAYMENT_TOTAL_ELEMENTS:
      return payload;

    default:
      return state;
  }
};

const totalPages = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_PAYMENT_TOTAL_PAGES:
      return payload;

    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYMENT_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: IPaySimpleError = INITIAL_ERROR,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYMENT_ERROR:
      return payload;
    default:
      return state;
  }
};

const paymentsReducer = combineReducers({
  data,
  pageNumber,
  pageSize,
  totalElements,
  totalPages,
  isPending,
  error
});

export default paymentsReducer;
